import { render } from "./EditInternship.vue?vue&type=template&id=69e6940f&scoped=true&ts=true"
import script from "./EditInternship.vue?vue&type=script&lang=ts"
export * from "./EditInternship.vue?vue&type=script&lang=ts"

import "./EditInternship.vue?vue&type=style&index=0&id=69e6940f&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e6940f"]])

export default __exports__